<template>
  <div>
    <div
      class="header-top basic-header"
      :class="{
        'box-shadow': isHeaderShadow,
        'header-visible': isHeaderVisible,
      }"
    >
      <div class="left">
        <div @click="$router.go(-1)" class="header-back">
          <svg-icon class="header-svg" icon-class="left-arrow" />
        </div>
        <transition name="el-fade-in-linear">
          <span v-show="!isScrollShow">{{ headerText }}</span>
        </transition>
      </div>
      <transition name="el-fade-in-linear">
        <div class="scroll-box" v-show="isScrollShow">
          <div class="left-scroll">
            <img
              class="scroll-head"
              :src="employeInfo.photoUrl ? employeInfo.photoUrl : defaultHead"
            />
            <div class="scroll-main">
              <div class="scoll-name">{{ employeInfo.name }}</div>
              <div class="scroll-post" v-if="employeInfo.post">
                {{ headPost }}
              </div>
            </div>
          </div>
          <div class="right-scroll">
            <el-button @click="goPrint">工牌打印</el-button>
            <el-button @click="switchAccountStatus">{{
              accountStatusBtn
            }}</el-button>
            <el-button @click="resetPassword">重置密码</el-button>
            <el-button
              v-if="employeInfo.status == '试用期'"
              @click="isRegularShow = true"
              >转正</el-button
            >
            <el-button @click="switchDimission">{{
              switchDimissionBtn
            }}</el-button>
          </div>
        </div>
      </transition>
    </div>
    <div class="basic-info">
      <div class="basic-head">
        <div class="head-main">
          <div class="main-left" :class="{ 'z-index': !isTagsShow }">
            <div class="head-box">
              <img
                class="head-img"
                :src="employeInfo.photoUrl ? employeInfo.photoUrl : defaultHead"
              />
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                :http-request="getFile"
                list-type="picture"
                :show-file-list="false"
                id="headUpload"
              >
                <div class="head-btn">更换头像</div>
              </el-upload>
            </div>
            <div class="head-items" v-if="employeInfo.creationTime">
              <div class="head-item">
                <span class="basic-name">{{ employeInfo.name }}</span>
                <img :src="medalImg" class="medal-img" v-if="medalImg" />
                <div class="job-num">{{ employeInfo.jobNum }}</div>
              </div>
              <div v-if="employeInfo.post">{{ headPost }}</div>
              <div class="encrypt-number">
                <span v-if="isShow.phoneNumber"
                  >联系电话：{{ employeInfo.phoneNumber }}</span
                >
                <span v-else-if="employeInfo.phoneNumber"
                  >联系电话：{{ employeInfo.phoneNumber.substring(0, 3) }}****{{
                    employeInfo.phoneNumber.substring(
                      employeInfo.phoneNumber.length - 4
                    )
                  }}</span
                >
                <div
                  class="show-svg"
                  v-if="employeInfo.phoneNumber"
                  @click="authLook('phoneNumber')"
                >
                  <svg-icon icon-class="hidden" v-if="isShow.phoneNumber" />
                  <svg-icon icon-class="show" v-else />
                </div>
                <span v-else>—</span>
              </div>
              <div v-if="employeInfo.firstWorkTime">
                首次入职时间/最近入职时间：{{
                  employeInfo.firstWorkTime | getTime
                }}/{{ employeInfo.workTime | getTime }}
              </div>
              <div v-else>入职时间：{{ employeInfo.workTime | getTime }}</div>
              <div class="head-tags">
                <div class="head-item tags-box" v-if="isTagsShow">
                  <div class="tags-items" v-if="employeInfo.tags.length">
                    <div
                      class="tag"
                      v-for="(item, index) in employeInfo.tags"
                      v-show="index < tagNum"
                      :key="index"
                    >
                      {{ item | valLength(7) }}
                    </div>
                    <div class="tag" v-if="employeInfo.tags.length > tagNum">
                      ...
                    </div>
                  </div>
                  <span class="tag-btn" @click="addTag">添加标签</span>
                </div>
                <div v-else class="tags-input">
                  <div class="input-box">
                    <div
                      class="tag"
                      v-for="(item, index) in employe.tags"
                      :key="index"
                    >
                      <span class="tag-text">{{ item }}</span>
                      <span @click="delTag(index)">
                        <svg-icon icon-class="tag-del" />
                      </span>
                    </div>
                    <el-input
                      v-model="headTag"
                      @change="submitTag(true)"
                      maxlength="7"
                      v-if="employe.tags.length < 5"
                    ></el-input>
                  </div>
                  <span class="input-btn" @click="submitTag(false)">保存</span>
                </div>
              </div>
            </div>
          </div>
          <div class="main-right">
            <div class="right-items">
              <div>
                员工状态
                <div
                  class="item-value"
                  :class="{ quitted: employeInfo.status == '已离职' }"
                >
                  {{ employeInfo.status | nullValue }}
                </div>
              </div>
              <div>
                累计工龄
                <div class="item-value">
                  {{ employeInfo.cumulativeWorkingTime }}
                </div>
              </div>
              <div>
                带训师
                <div class="item-value">
                  {{
                    employeInfo.isTrainingTeacher
                      ? employeInfo.trainingTeacherGrade
                      : "否"
                  }}
                </div>
              </div>
              <div>
                社保状态
                <div class="item-value">
                  {{ employeInfo.hasJoinedSocialInsurance ? "正常" : "无" }}
                </div>
              </div>
            </div>
            <div class="right-btns" v-show="isTagsShow">
              <!-- <el-button @click="goPrint">工牌打印</el-button> -->
              <el-button @click="switchAccountStatus">{{
                accountStatusBtn
              }}</el-button>
              <el-button @click="resetPassword">重置密码</el-button>
              <el-button
                v-if="employeInfo.status == '试用期'"
                @click="isRegularShow = true"
                >转正</el-button
              >
              <el-button @click="switchDimission">{{
                switchDimissionBtn
              }}</el-button>
            </div>
          </div>
        </div>
        <div class="head-line"></div>
        <div class="head-bottom">
          <div class="bottom-left" @click="editRemarks">
            <span v-if="employeInfo.more">{{ employeInfo.more }}</span>
            <span v-else>添加员工备注</span>
            <span class="mark-box">
              <svg-icon icon-class="edit" />
            </span>
          </div>
          <!-- <div class="bottom-right">
            <el-tooltip
              placement="top"
              popper-class="custom-tooltip"
              effect="light"
            >
              <div slot="content">打印</div>
              <span @click="goPrintInfo('print')">
                <svg-icon icon-class="print" />
              </span>
            </el-tooltip>
            <el-tooltip
              placement="top"
              popper-class="custom-tooltip"
              effect="light"
            >
              <div slot="content">下载</div>
              <span @click="goPrintInfo('download')">
                <svg-icon icon-class="derive-ico" />
              </span>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="to-audit" v-if="changeRecordlist.length">
        <p class="audit-top">该员工有待审核的异动调整信息：</p>
        <p
          class="audit-item"
          v-for="(item, index) in changeRecordFirst"
          :key="index"
        >
          <span
            >{{ item.description }} 提交人{{ item.creator }}&emsp;提交日期{{
              item.creationTime
            }}&nbsp;</span
          >
          <span class="audit-item-btn" @click="pass(item.id)">通过</span>&nbsp;
          <span class="audit-item-btn" @click="refuse(item.id)">驳回</span>
        </p>
      </div>
      <el-form
        label-position="left"
        label-width="6rem"
        v-if="employeInfo.creationTime"
        :rules="employeRules"
        :model="employe"
        ref="employeForm"
      >
        <div class="basic-item">
          <div v-if="isEditInfo.basic">
            <div class="basic-item-title">基本信息</div>
            <div class="basic-item-main">
              <div class="main-item">
                <el-form-item label="姓名" porp="name">
                  <el-input
                    v-model="employe.name"
                    placeholder="请输入姓名"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="出生日期">
                  <el-date-picker
                    align="center"
                    v-model="employe.birthday"
                    type="date"
                    placeholder="请选择出生日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="婚姻状况">
                  <el-select
                    v-model="employe.marriageStatus"
                    clearable
                    placeholder="请选择婚姻状况"
                  >
                    <el-option
                      v-for="item in marriageOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="籍贯">
                  <el-input
                    v-model="employe.native"
                    placeholder="请输入籍贯"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="招聘渠道">
                  <el-select
                    v-model="employe.recruitWay"
                    clearable
                    placeholder="请选择招聘渠道"
                  >
                    <el-option
                      v-for="item in recruitWayOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="家庭住址">
                  <el-input
                    v-model="employe.familyAddress"
                    placeholder="请输入家庭住址"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-item basic-item-right main-item-flex">
                <el-form-item label="性别">
                  <el-select
                    v-model="employe.sex"
                    clearable
                    placeholder="请选择性别"
                  >
                    <el-option
                      v-for="item in sexOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="身份证号">
                  <el-input
                    v-model="employe.identityCard"
                    placeholder="请输入身份证号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="民族">
                  <el-select
                    v-model="employe.nation"
                    clearable
                    placeholder="请选择民族"
                  >
                    <el-option
                      v-for="item in nationOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="政治面貌">
                  <el-select
                    v-model="employe.political"
                    clearable
                    placeholder="请选择政治面貌"
                  >
                    <el-option
                      v-for="item in politicalOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="带训师">
                  <el-select
                    v-model="employe.trainingTeacherGrade"
                    clearable
                    placeholder="请选择带训师等级"
                  >
                    <el-option
                      v-for="item in teacherGradeOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现居住地">
                  <el-input
                    v-model="employe.currentAddress"
                    placeholder="请输入现居住地"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="editInfo('basic')"
                >保存</el-button
              >
              <el-button @click="cancel('basic')">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              基本信息
              <div class="basic-edit" @click="isEditInfo.basic = true">
                管理
              </div>
            </div>
            <div class="basic-item-main basic-main-edit">
              <div class="main-item">
                <el-form-item label="姓名">{{
                  employeInfo.name | nullValue
                }}</el-form-item>
                <el-form-item label="工号">
                  <div class="job-num-box" v-if="!isEmIdShow">
                    <p>{{ employeInfo.emId | nullValue }}</p>
                    <div class="job-num-btn" @click="showEmid">手动分配</div>
                  </div>
                  <div class="job-num-box" v-else>
                    <el-input
                      v-model="employe.emId"
                      placeholder="请输入工号"
                      clearable
                    ></el-input>
                    <div class="job-num-btn" @click="updateEmid">保存</div>
                    <div class="job-num-btn" @click="isEmIdShow = false">
                      取消
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="渠道人员">
                  <div class="job-num-box" v-if="!isChannelShow">
                    <p>{{ employeInfo.channel | nullValue }}</p>
                    <div class="job-num-btn" @click="isChannelShow = true">
                      设置渠道
                    </div>
                  </div>
                  <div class="job-num-box" v-else>
                    <el-select
                      v-model="employe.channelId"
                      filterable
                      remote
                      placeholder="请输入渠道人员关键词"
                      @focus="getUser('')"
                      :remote-method="getUser"
                      :loading="getUserLoading"
                      style="width: 180px"
                    >
                      <el-option
                        v-for="item in channelOptions"
                        :key="item.id"
                        :label="item.name || '匿名'"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <div class="job-num-btn" @click="updateUser">保存</div>
                    <div class="job-num-btn" @click="isChannelShow = false">
                      取消
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="出生日期">{{
                  employeInfo.birthday | getTime
                }}</el-form-item>
                <el-form-item label="婚姻状况">{{
                  employeInfo.marriageStatus | nullValue
                }}</el-form-item>
                <el-form-item label="籍贯">{{
                  employeInfo.native | nullValue
                }}</el-form-item>
                <el-form-item label="招聘渠道">{{
                  employeInfo.recruitWay | nullValue
                }}</el-form-item>
                <el-form-item label="创建时间">{{
                  employeInfo.creationTime
                }}</el-form-item>
                <el-form-item label="最近更新时间">{{
                  employeInfo.lastModificationTime
                }}</el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="性别">{{
                  employeInfo.sex | nullValue
                }}</el-form-item>
                <el-form-item label="身份证号">
                  <div class="encrypt-number">
                    <span v-if="isShow.identityCard">{{
                      employeInfo.identityCard
                    }}</span>
                    <span v-else-if="employeInfo.identityCard"
                      >{{ employeInfo.identityCard[0] }}****************{{
                        employeInfo.identityCard[
                          employeInfo.identityCard.length - 1
                        ]
                      }}</span
                    >
                    <div
                      class="show-svg"
                      @click="authLook('identityCard')"
                      v-if="employeInfo.identityCard"
                    >
                      <svg-icon
                        icon-class="hidden"
                        v-if="isShow.identityCard"
                      />
                      <svg-icon icon-class="show" v-else />
                    </div>
                    <span v-else>—</span>
                  </div>
                </el-form-item>
                <el-form-item label="账号锁定">
                  <div
                    v-if="employeInfo.isLockout"
                    class="lockout-box is-lockout"
                  >
                    <svg-icon icon-class="status-close" />已锁定
                  </div>
                  <div v-else class="lockout-box not-lockout">
                    <svg-icon icon-class="success" />正常
                  </div>
                </el-form-item>
                <el-form-item label="民族">{{
                  employeInfo.nation | nullValue
                }}</el-form-item>
                <el-form-item label="政治面貌">{{
                  employeInfo.political | nullValue
                }}</el-form-item>
                <el-form-item label="带训师">{{
                  employeInfo.isTrainingTeacher
                    ? employeInfo.trainingTeacherGrade
                    : "否"
                }}</el-form-item>
                <el-form-item label="家庭住址">{{
                  employeInfo.familyAddress | nullValue
                }}</el-form-item>
                <el-form-item label="现居住地">{{
                  employeInfo.currentAddress | nullValue
                }}</el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div v-if="isEditInfo.contact" key="contact">
            <div class="basic-item-title">联系方式</div>
            <div class="basic-item-main">
              <div class="main-item">
                <el-form-item label="手机号" prop="phoneNumber">
                  <el-input
                    v-model="employe.phoneNumber"
                    placeholder="请输入手机号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="QQ账号">
                  <el-input
                    v-model="employe.qq"
                    placeholder="请输入QQ账号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="紧急联系人">
                  <el-input
                    v-model="employe.contactName"
                    placeholder="请输入紧急联系人"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="与联系人关系">
                  <el-input
                    v-model="employe.contactRelationship"
                    placeholder="请输入与紧急联系人关系"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="微信号">
                  <el-input
                    v-model="employe.wechat"
                    placeholder="请输入微信号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="employe.email"
                    placeholder="请输入邮箱"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="紧急联系电话" prop="contactPhoneNumber">
                  <el-input
                    v-model="employe.contactPhoneNumber"
                    placeholder="请输入紧急联系电话"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="editInfo('contact')"
                >保存</el-button
              >
              <el-button @click="cancel('contact')">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              联系方式
              <div class="basic-edit" @click="isEditInfo.contact = true">
                管理
              </div>
            </div>
            <div class="basic-item-main basic-main-edit">
              <div class="main-item">
                <el-form-item label="手机号">
                  <div class="encrypt-number phone-number">
                    <span v-if="isShow.phoneNumber">{{
                      employeInfo.phoneNumber
                    }}</span>
                    <span v-else-if="employeInfo.phoneNumber"
                      >{{ employeInfo.phoneNumber.substring(0, 3) }}****{{
                        employeInfo.phoneNumber.substring(
                          employeInfo.phoneNumber.length - 4
                        )
                      }}</span
                    >
                    <div
                      class="show-svg"
                      v-if="employeInfo.phoneNumber"
                      @click="authLook('phoneNumber')"
                    >
                      <svg-icon icon-class="hidden" v-if="isShow.phoneNumber" />
                      <svg-icon icon-class="show" v-else />
                    </div>
                    <span v-else>—</span>
                  </div>
                </el-form-item>
                <el-form-item label="QQ账号">{{
                  employeInfo.qq | nullValue
                }}</el-form-item>
                <el-form-item label="紧急联系人">{{
                  employeInfo.contactName | nullValue
                }}</el-form-item>
                <el-form-item label="与联系人关系">{{
                  employeInfo.contactRelationship | nullValue
                }}</el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="微信号">{{
                  employeInfo.wechat | nullValue
                }}</el-form-item>
                <el-form-item label="邮箱">{{
                  employeInfo.email | nullValue
                }}</el-form-item>
                <el-form-item label="紧急联系电话">
                  <div class="encrypt-number phone-number">
                    <span v-if="isShow.contactPhoneNumber">{{
                      employeInfo.contactPhoneNumber
                    }}</span>
                    <span v-else-if="employeInfo.contactPhoneNumber"
                      >{{
                        employeInfo.contactPhoneNumber.substring(0, 3)
                      }}****{{
                        employeInfo.contactPhoneNumber.substring(
                          employeInfo.contactPhoneNumber.length - 4
                        )
                      }}</span
                    >
                    <div
                      class="show-svg"
                      v-if="employeInfo.contactPhoneNumber"
                      @click="authLook('contactPhoneNumber')"
                    >
                      <svg-icon
                        icon-class="hidden"
                        v-if="isShow.contactPhoneNumber"
                      />
                      <svg-icon icon-class="show" v-else />
                    </div>
                    <span v-else>—</span>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div v-if="isEditInfo.status" key="status">
            <div class="basic-item-title">员工状态</div>
            <div class="basic-item-main">
              <div class="main-item">
                <el-form-item label="入职时间" prop="workTime">
                  <el-date-picker
                    align="center"
                    v-model="employe.workTime"
                    type="date"
                    placeholder="请选择入职时间"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="预计转正日期" prop="effectiveTime">
                  <el-date-picker
                    align="center"
                    v-model="employe.regularWorkTime"
                    type="date"
                    placeholder="请选择生效日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item :label="employeInfo.status">
                  <el-select
                    v-model="employe.tryWorkDays"
                    clearable
                    :placeholder="'请选择' + tryWorkDaysLabel"
                  >
                    <el-option value="30" label="一个月"></el-option>
                    <el-option value="60" label="两个月"></el-option>
                    <el-option value="90" label="三个月"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="main-item basic-item-right">
                <el-form-item label="工龄">
                  <el-input
                    v-model="employe.currentWorkingTime"
                    type="number"
                    placeholder="请输入工龄（天）"
                  ></el-input>
                </el-form-item>
                <el-form-item label="转正考试">
                  <el-radio-group v-model="employe.hasPassedRegularWorkTest">
                    <el-radio :label="true">通过</el-radio>
                    <el-radio :label="false">未通过</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="editInfo('status')"
                >保存</el-button
              >
              <el-button @click="cancel('status')">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              员工状态
              <div class="basic-edit" @click="isEditInfo.status = true">
                管理
              </div>
            </div>
            <div class="basic-item-main basic-main-edit">
              <div class="main-item">
                <el-form-item label="状态">{{
                  employeInfo.status | nullValue
                }}</el-form-item>
                <el-form-item
                  :label="employeInfo.status"
                  v-if="
                    employeInfo.status == '试用期' ||
                    employeInfo.status == '复岗期'
                  "
                  >{{ employeInfo.tryWorkDays | filterTryDays }}</el-form-item
                >
                <el-form-item
                  label="转正日期"
                  v-if="
                    employeInfo.status == '正式员工' ||
                    employeInfo.status == '已离职'
                  "
                  >{{ employeInfo.regularWorkTime | getTime }}</el-form-item
                >
                <el-form-item label="预计转正日期" v-else>{{
                  employeInfo.regularWorkTime | getTime
                }}</el-form-item>
                <div v-if="employeInfo.status == '已离职'">
                  <el-form-item label="离职时间">{{
                    employeInfo.firedTime | getTime
                  }}</el-form-item>
                  <el-form-item label="离职原因">{{
                    employeInfo.firedReason | nullValue
                  }}</el-form-item>
                </div>
                <el-form-item
                  label="转正考试"
                  v-if="
                    employeInfo.status != '试用期' &&
                    employeInfo.status != '已离职'
                  "
                  >{{
                    employeInfo.hasPassedRegularWorkTest ? "通过" : "未通过"
                  }}</el-form-item
                >
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="入职日期">{{
                  employeInfo.workTime | getTime
                }}</el-form-item>
                <el-form-item label="工龄">{{
                  employeInfo.currentWorkingTime
                }}</el-form-item>
                <el-form-item
                  label="转正考试"
                  v-if="
                    employeInfo.status == '试用期' ||
                    employeInfo.status == '已离职'
                  "
                  >{{
                    employeInfo.hasPassedRegularWorkTest ? "通过" : "未通过"
                  }}</el-form-item
                >
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">
            岗位信息
            <span class="post-symbol">*</span>
          </div>
          <el-button type="primary" @click="addPosition" class="add-position"
            >添加新岗位</el-button
          >
          <el-table :data="jobs" style="width: 100%" header-align="center">
            <el-table-column prop="grade" label="职务/职级" width="200">
              <template slot-scope="scope">
                <div class="grade-box">
                  {{ scope.row.post.name }}/{{ scope.row.position.name }}
                  <div class="grade-main" v-if="scope.row.isMajor">主岗</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="organizationUnit.name"
              label="部门"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="effectiveTime"
              label="生效时间"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">{{
                scope.row.effectiveTime | filterSpaceTime
              }}</template>
            </el-table-column>
            <el-table-column
              prop="more"
              label="备注"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">{{
                scope.row.more | nullValue
              }}</template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <div class="table-operation">
                  <el-button
                    @click.native.prevent="
                      adjustPosition(scope.$index, scope.row)
                    "
                    type="text"
                    >岗位调整</el-button
                  >
                  <el-button
                    @click.native.prevent="setUpPosition(scope.row)"
                    type="text"
                    v-if="!scope.row.isMajor"
                    >设为主岗位</el-button
                  >
                  <el-button
                    @click.native.prevent="deletePosition(scope.row)"
                    v-if="!scope.row.isMajor"
                    type="text"
                    class="del-btn"
                    >移除</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <template slot="empty">当前岗位列表为空</template>
          </el-table>
        </div>
        <div class="basic-item">
          <div v-if="isEditInfo.socialSecurity">
            <div class="basic-item-title">社保信息</div>
            <div class="basic-item-main">
              <div class="main-item">
                <el-form-item label="工资卡号">
                  <el-input
                    v-model="employe.cardNumber"
                    placeholder="请输入工资卡号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="银行">
                  <el-select
                    v-model="employe.cardBank"
                    clearable
                    placeholder="请选择银行"
                  >
                    <el-option
                      v-for="item in cardBankOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属城市">
                  <el-input
                    v-model="employe.cardCity"
                    placeholder="请输入银行卡所属城市"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="支行">
                  <el-input
                    v-model="employe.cardBankName"
                    placeholder="请输入支行"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否参保">
                  <el-radio-group v-model="employe.hasJoinedSocialInsurance">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- TODO:缺少社保账号/社保方案字段 -->
                <!-- <el-form-item label="社保账号" v-if="employe.hasJoinedSocialInsurance">
                <el-input v-model="employe.cardNumber" placeholder="请输入社保账号" clearable></el-input>
                </el-form-item>-->
                <!-- <el-form-item label="社保方案">
                <el-select v-model="employe.socialSecurity.scheme" clearable placeholder="请选择社保方案">
                  <el-option
                    v-for="item in socialSecurityScheme"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                </el-form-item>-->
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="editInfo('socialSecurity')"
                >保存</el-button
              >
              <el-button @click="cancel('socialSecurity')">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              社保信息
              <div class="basic-edit" @click="isEditInfo.socialSecurity = true">
                管理
              </div>
            </div>
            <div class="basic-item-main basic-main-edit">
              <div class="main-item">
                <el-form-item label="工资卡号">{{
                  employeInfo.cardNumber | nullValue
                }}</el-form-item>
                <el-form-item label="银行">{{
                  employeInfo.cardBank | nullValue
                }}</el-form-item>
                <el-form-item label="所属城市">{{
                  employeInfo.cardCity | nullValue
                }}</el-form-item>

                <!-- <el-form-item label="社保账号">{{employeInfo.number}}</el-form-item> -->
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="支行">{{
                  employeInfo.cardBankName | nullValue
                }}</el-form-item>
                <el-form-item label="是否参保">{{
                  employeInfo.hasJoinedSocialInsurance ? "是" : "否"
                }}</el-form-item>
                <!-- <el-form-item label="社保方案">{{employeInfo.scheme}}</el-form-item> -->
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div v-if="isEditInfo.education">
            <div class="basic-item-title">教育信息</div>
            <div class="basic-item-main">
              <div class="main-item">
                <el-form-item label="学历">
                  <el-select
                    v-model="employe.educationType"
                    clearable
                    placeholder="请选择学历"
                  >
                    <el-option
                      v-for="item in educationOptions"
                      :key="item.option"
                      :label="item.option"
                      :value="item.option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="专业">
                  <el-input
                    v-model="employe.profession"
                    placeholder="请输入专业"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="毕业院校">
                  <el-input
                    v-model="employe.college"
                    placeholder="请输入毕业院校"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="毕业时间">
                  <el-date-picker
                    align="center"
                    v-model="employe.graduationTime"
                    type="date"
                    placeholder="请选择毕业时间"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="group-btn">
              <el-button type="primary" @click="editInfo('education')"
                >保存</el-button
              >
              <el-button @click="cancel('education')">取消</el-button>
            </div>
          </div>
          <div v-else>
            <div class="basic-item-title basic-title-edit">
              教育信息
              <div class="basic-edit" @click="isEditInfo.education = true">
                管理
              </div>
            </div>
            <div class="basic-item-main basic-main-edit">
              <div class="main-item">
                <el-form-item label="学历">{{
                  employeInfo.educationType | nullValue
                }}</el-form-item>
                <el-form-item label="专业">{{
                  employeInfo.profession | nullValue
                }}</el-form-item>
              </div>
              <div class="main-item basic-item-right">
                <el-form-item label="毕业院校">{{
                  employeInfo.college | nullValue
                }}</el-form-item>
                <el-form-item label="毕业时间">{{
                  employeInfo.graduationTime | getTime
                }}</el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <el-dialog
        :title="positionEditTitle"
        :visible.sync="isPositionShow"
        width="655px"
        custom-class="employe-dialog"
        @close="handleClose('positionForm')"
      >
        <el-form
          :model="positionForm"
          label-position="left"
          label-width="5rem"
          :rules="positionRules"
          ref="positionForm"
        >
          <el-form-item
            label="原岗位"
            v-if="originalPosition.post && positionEditTitle != '添加新岗位'"
          >
            {{ originalPosition.organizationUnit.name }}-{{
              originalPosition.post.name
            }}-{{ originalPosition.position.name }}
          </el-form-item>
          <el-form-item label="岗位" required>
            <div class="select-inline">
              <el-form-item prop="grade">
                <el-cascader
                  v-model="positionForm.grade"
                  :options="posts"
                  :props="{ expandTrigger: 'hover' }"
                  placeholder="请选择职务职级"
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item prop="organization" class="tree-select">
                <treeselect
                  noOptionsText="未找到对应数据"
                  noResultsText="未找到对应数据"
                  v-model="positionForm.organization"
                  value-consists-of="BRANCH_PRIORITY"
                  :multiple="false"
                  :options="orgs"
                  :normalizer="normalizer"
                  :flatten-search-results="false"
                  :value="['disabled-checked']"
                  placeholder="请选择部门"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="生效日期" prop="effectiveTime">
            <el-date-picker
              align="center"
              v-model="positionForm.effectiveTime"
              type="date"
              placeholder="请选择生效日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="positionForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isPositionShow = false">取消</el-button>
          <el-button type="primary" @click="submitPosition('positionForm')"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="员工离职"
        :visible.sync="isDimissionShow"
        width="600px"
        custom-class="employe-dialog regular-dialog"
        @close="handleClose('dimissionForm')"
      >
        <el-form
          :model="dimissionForm"
          label-position="left"
          label-width="6rem"
          ref="dimissionForm"
          :rules="dimissionRules"
        >
          <el-form-item label="离职原因" prop="firedReason">
            <el-select
              v-model="dimissionForm.firedReason"
              clearable
              placeholder="请选择离职原因"
            >
              <el-option
                v-for="item in firedReasonOptions"
                :key="item.option"
                :label="item.option"
                :value="item.option"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="离职日期" prop="effectiveTime">
            <el-date-picker
              align="center"
              v-model="dimissionForm.effectiveTime"
              type="date"
              placeholder="请选择离职日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="dimissionForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item
            :class="
              !dimissionForm.imgList.length &&
              dimissionForm.textList.length == 1
                ? ''
                : 'auto-height'
            "
            label="附件"
            v-if="
              dimissionForm.imgList.length > 0 ||
              dimissionForm.textList.length > 0
            "
          >
            <div class="add-record-content">
              <div class="flex">
                <div
                  class="img-group"
                  v-for="(item, index) in dimissionForm.imgList"
                  :key="index"
                >
                  <el-image class="img" :src="item.url" fit="cover"></el-image>
                  <div class="info">
                    <div class="flex-between">
                      <div>{{ item.name | valLength(8) }}</div>
                      <div
                        @click="delDimissionFile('imgList', index, item.uid)"
                      >
                        <svg-icon
                          class="del-icon"
                          icon-class="del-ico"
                        ></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="files-group">
                <div
                  class="file"
                  v-for="(item, index) in dimissionForm.textList"
                  :key="index"
                >
                  <span class="file-title">【资料文件】 {{ item.name }}</span>
                  <span
                    class="file-action"
                    @click="delDimissionFile('textList', index, item.uid)"
                    >移除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-tip dialog-tip-dimission">
          *保存后提交相关工作人员审核，审核通过后将按照“离职日期”执行离职，如“离职原因”不满足需要，请至“系统设置”中的“基础字段配置”页面进行设置。
        </div>
        <div slot="footer" class="dialog-footer">
          <el-upload
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="uploadDimissionChange"
            :file-list="dimissionFileList"
            :show-file-list="false"
            :auto-upload="false"
            multiple
            accept=".jpg, .png, .jpeg, .txt, .pdf, .doc, .docx, .xlsx"
          >
            <el-button @click="isDimissionShow = false">取消</el-button>
            <el-button slot="trigger" class="upload-btn">上传附件</el-button>
            <el-button
              type="primary"
              @click="submitDimission('dimissionForm')"
              :loading="isBtnLoading"
              >确定</el-button
            >
          </el-upload>
        </div>
      </el-dialog>
      <el-dialog
        title="员工转正"
        :visible.sync="isRegularShow"
        width="600px"
        custom-class="regular-dialog employe-dialog"
        @close="handleClose('regularForm')"
      >
        <el-form
          :model="regularForm"
          label-position="left"
          label-width="6rem"
          ref="regularForm"
          :rules="regularRules"
        >
          <el-form-item label="预计转正日期" class="margin-bottom">{{
            this.employeInfo.regularWorkTime | getTime
          }}</el-form-item>
          <el-form-item
            label="实际转正日期"
            prop="effectiveTime"
            class="regular-date"
          >
            <el-date-picker
              align="center"
              v-model="regularForm.effectiveTime"
              type="date"
              placeholder="请选择实际转正日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="regularForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item
            :class="
              !regularForm.imgList.length && regularForm.textList.length == 1
                ? ''
                : 'auto-height'
            "
            label="附件"
            v-if="
              regularForm.imgList.length > 0 || regularForm.textList.length > 0
            "
          >
            <div class="add-record-content">
              <div class="flex">
                <div
                  class="img-group"
                  v-for="(item, index) in regularForm.imgList"
                  :key="index"
                >
                  <el-image class="img" :src="item.url" fit="cover"></el-image>
                  <div class="info">
                    <div class="flex-between">
                      <div>{{ item.name | valLength(8) }}</div>
                      <div @click="delRegularFile('imgList', index, item.uid)">
                        <svg-icon
                          class="del-icon"
                          icon-class="del-ico"
                        ></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="files-group">
                <div
                  class="file"
                  v-for="(item, index) in regularForm.textList"
                  :key="index"
                >
                  <span class="file-title">【资料文件】 {{ item.name }}</span>
                  <span
                    class="file-action"
                    @click="delRegularFile('textList', index, item.uid)"
                    >移除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-tip dialog-tip-regular">
          *保存后提交相关工作人员审核，审核通过后将按照“实际转正日期”执行转正。
        </div>
        <div slot="footer" class="dialog-footer">
          <el-upload
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="uploadRegularChange"
            :file-list="regularFileList"
            :show-file-list="false"
            :auto-upload="false"
            multiple
            accept=".jpg, .png, .jpeg, .txt, .pdf, .doc, .docx, .xlsx"
          >
            <el-button @click="isRegularShow = false">取消</el-button>
            <el-button slot="trigger" class="upload-btn">上传附件</el-button>
            <el-button
              type="primary"
              @click="submitRegular('regularForm')"
              :loading="isBtnLoading"
              >确定</el-button
            >
          </el-upload>
        </div>
      </el-dialog>
      <el-dialog
        title="员工再入职"
        :visible.sync="isInductionShow"
        width="600px"
        custom-class="regular-dialog employe-dialog"
        @close="handleClose('inductionForm')"
      >
        <el-form
          :model="inductionForm"
          label-position="left"
          label-width="5rem"
          ref="inductionForm"
          :rules="inductionRules"
        >
          <el-form-item
            label="原岗位"
            class="margin-bottom"
            v-if="employeInfo.post"
            >{{ this.headPost }}</el-form-item
          >
          <el-form-item label="再入职岗位" required>
            <div class="select-inline">
              <el-form-item prop="grade">
                <el-cascader
                  v-model="inductionForm.grade"
                  :options="posts"
                  :props="{ expandTrigger: 'hover' }"
                  placeholder="请选择职务职级"
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item prop="organization">
                <treeselect
                  noOptionsText="未找到对应数据"
                  noResultsText="未找到对应数据"
                  v-model="inductionForm.organization"
                  value-consists-of="BRANCH_PRIORITY"
                  :multiple="false"
                  :options="orgs"
                  :normalizer="normalizer"
                  :flatten-search-results="false"
                  :value="['disabled-checked']"
                  placeholder="请选择部门"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="生效日期" prop="effectiveTime">
            <el-date-picker
              align="center"
              v-model="inductionForm.effectiveTime"
              type="date"
              placeholder="请选择生效日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="员工状态">
            <div class="select-inline">
              <el-form-item
                :class="
                  inductionForm.status == 'nomail'
                    ? 'custom-width'
                    : 'induction-status'
                "
              >
                <el-select
                  v-model="inductionForm.status"
                  placeholder="请选择员工状态"
                >
                  <el-option value="probation" label="试用期"></el-option>
                  <el-option value="recovery" label="复岗期"></el-option>
                  <el-option value="nomail" label="正式员工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="inductionForm.status != 'nomail'"
                class="work-days"
              >
                <el-select
                  v-model="inductionForm.tryWorkDays"
                  :placeholder="'请选择' + tryWorkDaysLabel"
                >
                  <el-option value="30" label="一个月"></el-option>
                  <el-option value="60" label="两个月"></el-option>
                  <el-option value="90" label="三个月"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="inductionForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item
            :class="
              !inductionForm.imgList.length &&
              inductionForm.textList.length == 1
                ? ''
                : 'auto-height'
            "
            label="附件"
            v-if="
              inductionForm.imgList.length > 0 ||
              inductionForm.textList.length > 0
            "
          >
            <div class="add-record-content">
              <div class="flex">
                <div
                  class="img-group"
                  v-for="(item, index) in inductionForm.imgList"
                  :key="index"
                >
                  <el-image class="img" :src="item.url" fit="cover"></el-image>
                  <div class="info">
                    <div class="flex-between">
                      <div>{{ item.name | valLength(8) }}</div>
                      <div
                        @click="delInductionFile('imgList', index, item.uid)"
                      >
                        <svg-icon
                          class="del-icon"
                          icon-class="del-ico"
                        ></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="files-group">
                <div
                  class="file"
                  v-for="(item, index) in inductionForm.textList"
                  :key="index"
                >
                  <span class="file-title">【资料文件】 {{ item.name }}</span>
                  <span
                    class="file-action"
                    @click="delInductionFile('textList', index, item.uid)"
                    >移除</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-tip">
          *保存后提交相关工作人员审核，审核通过后将按照“生效日期”执行再入职。
        </div>
        <div slot="footer" class="dialog-footer">
          <el-upload
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="uploadInductionChange"
            :file-list="inductionFileList"
            :show-file-list="false"
            :auto-upload="false"
            multiple
            accept=".jpg, .png, .jpeg, .txt, .pdf, .doc, .docx, .xlsx"
          >
            <el-button @click="isInductionShow = false">取消</el-button>
            <el-button slot="trigger" class="upload-btn">上传附件</el-button>
            <el-button
              type="primary"
              @click="submitInduction('inductionForm')"
              :loading="isBtnLoading"
              >确定</el-button
            >
          </el-upload>
        </div>
      </el-dialog>
      <el-dialog
        title="异动驳回"
        :visible.sync="isRejectShow"
        width="550px"
        custom-class="employe-dialog"
        @close="handleClose('rejectForm')"
      >
        <el-form
          :model="rejectForm"
          label-position="left"
          label-width="4rem"
          ref="rejectForm"
          :rules="rejectRules"
        >
          <el-form-item label="驳回原因" prop="reason" class="auto-height">
            <el-input
              type="textarea"
              v-model="rejectForm.reason"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isRejectShow = false">取消</el-button>
          <el-button type="primary" @click="submitReject('rejectForm')"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="员工备注"
        :visible.sync="isRemarkShow"
        width="550px"
        custom-class="employe-remark employe-dialog"
      >
        <el-form :model="remarkForm">
          <el-input
            type="textarea"
            v-model="remarkForm.more"
            maxlength="60"
            show-word-limit
            resize="none"
            placeholder="请填写员工备注"
          ></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isRemarkShow = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="账户冻结"
        :visible.sync="isLockShow"
        width="550px"
        custom-class="employe-dialog lock-dialog"
        @close="handleClose('lockForm')"
      >
        <el-form
          :model="lockForm"
          label-position="left"
          label-width="4rem"
          ref="lockForm"
        >
          <el-form-item label="冻结原因" prop="reason" class="auto-height">
            <el-input
              type="textarea"
              v-model="lockForm.more"
              maxlength="60"
              show-word-limit
              resize="none"
              :placeholder="'请填写账户冻结原因'"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-tip">*账户一旦冻结，将不能登录使用</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isLockShow = false">取消</el-button>
          <el-button type="primary" @click="submitLock">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="主岗调整"
        :visible.sync="isMajorJobShow"
        width="655px"
        custom-class="regular-dialog employe-dialog"
        @close="handleClose('majorJobForm')"
      >
        <el-form
          label-position="left"
          label-width="5rem"
          ref="majorJobForm"
          :rules="majorJobRules"
          :model="majorJobForm"
        >
          <el-form-item label="现主岗">{{ headPost }}</el-form-item>
          <el-form-item label="调整为">{{ majorJob }}</el-form-item>
          <el-form-item label="生效日期" prop="effectiveTime">
            <el-date-picker
              align="center"
              v-model="majorJobForm.effectiveTime"
              type="date"
              placeholder="请选择生效日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="majorJobForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isMajorJobShow = false">取消</el-button>
          <el-button type="primary" @click="submitMajorJob('majorJobForm')"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import elementResizeDetectorMaker from "element-resize-detector"; // 盒子大小监听插件
import { getUserSettings, getIdentitySettings } from "@/http/api/system";
import { getPostAllTree } from "@/http/api/position";
import { getOrgAllTree } from "@/http/api/organization";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { dateFormat } from "@/common/filters";
import { validatePhone, validateEmail } from "@/utils/validate";
import {
  getUserDetails,
  updateUser,
  resetPassword,
  userLockout,
  updateEmid,
  getUserJobs,
  updateMajorJob,
  removeUserJob,
  addUserJob,
  updateUserJobs,
  getChangeRecords,
  changeRecordsReview,
  updateStatus,
  uploadMaterials,
  getUsersSearch,
} from "@/http/api/employe";
import { tree } from "@/utils/tree";

export default {
  components: {
    Treeselect,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateContactPhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateEmails = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error("邮箱输入不正确"));
      } else {
        callback();
      }
    };
    return {
      normalizer(node) {
        if (node.data && node.data.id) {
          return {
            id: node.data.id + " " + node.data.name,
            label: node.data.name,
            children: node.children,
          };
        }
      },
      id: this.$route.params.id,
      permissions: this.$store.getters.permissions,
      screenWidth: document.body.clientWidth, // 屏幕宽度
      headerText: "分销人员",
      headTag: "",
      majorJob: "",
      lockTitle: "",
      lockInfo: "",
      defaultPassword: "",
      refuseIdRecordId: "", // 驳回异动id
      defaultHead: require("../../../../../assets/image/default-head.png"),
      years2: require("../../../../../assets/image/2years.png"),
      years5: require("../../../../../assets/image/5years.png"),
      years10: require("../../../../../assets/image/10years.png"),
      uploadText: "点击上传",
      positionEditTitle: "", // 岗位异动窗口标题
      isPositionShow: false, // 岗位窗口显示
      isJobNumInput: false, // 工号手动输入
      isDimissionShow: false, // 离职窗口显示
      isRejectShow: false, // 驳回窗口显示
      isRemarkShow: false, // 标签备注窗口显示
      isRemarkChange: false, // 是否修改备注
      isRegularShow: false, // 转正窗口显示
      isMajorJobShow: false, // 设置主岗窗口
      isInductionShow: false, // 再入职窗口
      isTagsShow: true, // 标签输入框显示
      isScrollShow: false, // 头部滚动内容显示
      isHeaderShadow: false, // 头部阴影显示
      isHeaderVisible: false, // 滚动头部显示
      isLockShow: false, // 冻结窗口显示
      isEmIdShow: false, // 工号输入框显示
      isChannelShow: false, // 渠道人员下拉框显示
      channelOptions: [],
      getUserLoading: false,
      loading: true, // 初始化加载
      isTagChange: false, // 是否修改标签
      isBtnLoading: false, // 按钮加载中
      isManageJobsAuth: false, // 岗位管理权限
      isLookPhoneAuth: false, // 查看手机号权限
      isLookIdCardAuth: false, // 查看身份证权限
      originalPosition: {}, // 岗位窗口中的原岗位
      dimissionForm: {
        status: "",
        firedReason: "",
        effectiveTime: "",
        more: "",
        imgList: [],
        textList: [],
      }, // 离职表单
      majorJobForm: {
        effectiveTime: "",
        more: "",
      }, // 设置主岗位表单
      regularForm: {
        effectiveTime: "",
        more: "",
        imgList: [],
        textList: [],
      }, // 转正表单
      inductionForm: {
        status: "probation",
        tryWorkDays: "三个月",
        grade: [],
        organization: null,
        effectiveTime: "",
        more: "",
        isMajor: true,
        imgList: [],
        textList: [],
      }, // 再入职表单
      positionForm: {
        grade: [],
        organization: null,
        effectiveTime: "",
        more: "",
        isMajor: false,
      }, // 岗位表单
      rejectForm: {
        reason: "",
      }, // 驳回表单
      remarkForm: {
        more: "",
      }, // 备注表单
      lockForm: {
        more: "",
      }, // 冻结表单
      employeRules: {
        name: [
          {
            required: true,
            message: "请输入用户姓名",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          { required: true, trigger: "blur", validator: validatePhoneNumber },
        ],
        contactPhoneNumber: [
          {
            required: false,
            trigger: "blur",
            validator: validateContactPhoneNumber,
          },
        ],
        email: [
          { required: false, trigger: "blur", validator: validateEmails },
        ],
        workTime: [
          { required: true, message: "请选择入职时间", trigger: "change" },
        ],
      }, // 员工表单规则
      positionRules: {
        grade: [
          { required: true, message: "请选择职务职级", trigger: "change" },
        ],
        organization: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        effectiveTime: [
          { required: true, message: "请选择生效日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 创建岗位规则
      inductionRules: {
        grade: [
          { required: true, message: "请选择职务职级", trigger: "change" },
        ],
        organization: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        effectiveTime: [
          { required: true, message: "请选择生效日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 再入职规则
      dimissionRules: {
        firedReason: [
          { required: true, message: "请选择离职原因", trigger: "change" },
        ],
        effectiveTime: [
          { required: true, message: "请选择离职日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 离职规则
      rejectRules: {
        reason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      }, // 驳回规则
      regularRules: {
        effectiveTime: [
          { required: true, message: "请选择实际转正日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 转正规则
      majorJobRules: {
        effectiveTime: [
          { required: true, message: "请选择生效日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 设置主岗规则
      isShow: {
        identityCard: false,
        phoneNumber: false,
        contactPhoneNumber: false,
      }, // 显示加密字段
      isEditInfo: {
        basic: false,
        contact: false,
        socialSecurity: false,
        education: false,
        status: false,
      }, // 显示管理模块
      employe: {}, // 员工表单对象
      employeInfo: {}, // 员工详情信息
      majorJobInfo: {}, // 主岗位信息
      photoFile: {}, // 头像
      changeRecordlist: [], // 异动列表
      changeRecordFirst: [], // 第一个异动
      sexOptions: [], // 性别选项
      marriageOptions: [], // 婚姻选项
      educationOptions: [], // 教育背景
      politicalOptions: [], // 政治背景
      recruitWayOptions: [], // 招聘渠道
      cardBankOptions: [], // 社保绑定的银行
      nationOptions: [], // 民族选项
      teacherGradeOptions: [], // 带训师等级
      firedReasonOptions: [], // 离职原因
      posts: [], // 职位列表
      orgs: [], // 组织列表
      jobs: [], // 岗位列表
      regularFileList: [], // 转正文件
      dimissionFileList: [], // 离职文件
      inductionFileList: [], // 再入职文件
      isHeaderInit: false,
    };
  },
  computed: {
    tryWorkDaysLabel() {
      switch (this.inductionForm.status) {
        case "recovery":
          return "复岗期限";
        case "probation":
        default:
          return "试用期限";
      }
    },
    tagNum() {
      let width = this.screenWidth;
      if (width <= 1680) {
        return 3;
      } else if (width <= 1920) {
        return 4;
      } else {
        return 5;
      }
    },
    statusBtnText() {
      return this.employe.status == "离职" ? "再入职" : "离职";
    },
    medalImg() {
      // 工龄勋章
      let year = this.employeInfo.cumulativeWorkingTime;
      if (year && year.includes("年")) {
        let years = year.split("年")[0];
        if (years > 1 && years < 5) {
          return this.years2;
        } else if (years >= 5 && years < 10) {
          return this.years5;
        } else if (years >= 10) {
          return this.years10;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    headPost() {
      if (this.employe.post) {
        return (
          this.employe.organizationUnit +
          "-" +
          this.employe.post +
          "-" +
          this.employe.position
        );
      } else {
        return "—";
      }
    },
    accountStatusBtn() {
      return this.employeInfo.isLockout ? "账户解冻" : "账户冻结";
    },
    switchDimissionBtn() {
      return this.employeInfo.status == "已离职" ? "再入职" : "离职";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取渠道人员
    getUser(e) {
      this.getUserLoading = true;
      var params = {
        posts: ["渠道经理", "渠道总监"],
        filter: e,
        skipCount: 0,
        maxResultCount: 999,
      };
      let query = "";
      for (var key in params) {
        if (params[key] !== null && params[key] !== "") {
          if (
            key == "postIds" ||
            key == "positionIds" ||
            key == "organizationUnitIds" ||
            key == "posts"
          ) {
            params[key].forEach((element) => {
              query = `${key}=${element}&${query}`;
            });
          } else {
            query = `${key}=${params[key]}&${query}`;
          }
        }
      }
      getUsersSearch(query).then((res) => {
        this.getUserLoading = false;
        this.channelOptions = res.result.items;
      });
    },
    // 初始化
    init() {
      this.getUser("");
      let el = document.querySelector(".main-container");
      el.addEventListener("scroll", this.scrollScreen);
      if (!this.isHeaderInit) {
        this.erd = elementResizeDetectorMaker();
        this.erd.listenTo(el, this.headerInit);
        this.headerInit();
      }
      this.getUserInfo();
      this.getUserSettings();
      this.getIdentitySettings();
      if (!this.posts.length) {
        this.getPosts();
      }
      this.getOrgs();
      this.getUserJobs();
      this.isManageJobsAuth = this.permissions["System.UserSettings.Update"];
      this.isLookPhoneAuth =
        this.permissions["RocketIdentity.Users.LookPhoneNumber"];
      this.isLookIdCardAuth =
        this.permissions["RocketIdentity.Users.LookIdCard"];
    },

    // 获取用户岗位信息
    getUserJobs() {
      getUserJobs(this.id).then((res) => {
        if (res.result.items.length) {
          this.jobs = res.result.items;
          // 主岗放首位
          let index = this.jobs.findIndex((el) => {
            return el.isMajor == true;
          });
          this.jobs.unshift(this.jobs.splice(index, 1)[0]);
        }
      });
    },
    // 获取头像
    getFile(item) {
      this.photoFile = item.file;
      this.updateUser();
    },
    // 获取用户配置字段
    getUserSettings() {
      getUserSettings().then((res) => {
        res.result.map((el) => {
          if (el.name == "Deer.User.Collection.Sex") {
            this.sexOptions = el.value;
          } else if (el.name == "Deer.User.Collection.MarriageStatus") {
            this.marriageOptions = el.value;
          } else if (el.name == "Deer.User.Collection.EducationType") {
            this.educationOptions = el.value;
          } else if (el.name == "Deer.User.Collection.Political") {
            this.politicalOptions = el.value;
          } else if (el.name == "Deer.User.Collection.RecruitWay") {
            this.recruitWayOptions = el.value;
          } else if (el.name == "Deer.User.Collection.CardBank") {
            this.cardBankOptions = el.value;
          } else if (el.name == "Deer.User.Collection.Nation") {
            this.nationOptions = el.value;
          } else if (el.name == "Deer.User.Collection.FiredReason") {
            this.firedReasonOptions = el.value;
          } else if (el.name == "Deer.User.Collection.TrainingTeacherGrade") {
            this.teacherGradeOptions = el.value;
          }
        });
      });
    },
    // 获取密码配置
    getIdentitySettings() {
      getIdentitySettings().then((res) => {
        res.result.map((el) => {
          if (el.name == "Rocket.Identity.Password.User") {
            this.defaultPassword = el.value;
          }
        });
      });
    },
    // 获取职位
    getPosts() {
      getPostAllTree({ loadMode: 2 }).then((res) => {
        tree(res.result.items).map((item) => {
          this.posts.push({
            value: item.data.id + " " + item.data.name,
            label: item.data.name,
            children: item.children,
          });
        });
        this.posts.forEach((item) => {
          let arr = [];
          if (item.children) {
            item.children.map((i) => {
              arr.push({
                value: i.data.id + " " + i.data.name,
                label: i.data.name,
              });
            });
            item.children = arr;
          }
        });
      });
    },
    // 获取组织
    getOrgs() {
      getOrgAllTree({ loadMode: 2 }).then((res) => {
        this.orgs = tree(res.result.items);
      });
    },
    // 查看手机号/身份证号验证权限
    authLook(v) {
      let msg = v == "identityCard" ? "身份证号" : "联系电话",
        auth =
          v == "identityCard" ? this.isLookIdCardAuth : this.isLookPhoneAuth;
      if (auth) {
        this.isShow[v] = !this.isShow[v];
      } else {
        this.$message.warning({
          message: `您暂无查看${msg}权限`,
          showClose: true,
        });
      }
    },
    // 删除离职文件
    delDimissionFile(key, index, uid) {
      this.dimissionForm[key].splice(index, 1);
      for (var i = 0; i < this.dimissionFileList.length; i++) {
        if (this.dimissionFileList[i].uid == uid) {
          this.dimissionFileList.splice(i, 1);
          return;
        }
      }
    },
    // 删除再入职文件
    delInductionFile(key, index, uid) {
      this.inductionForm[key].splice(index, 1);
      for (var i = 0; i < this.inductionFileList.length; i++) {
        if (this.inductionFileList[i].uid == uid) {
          this.inductionFileList.splice(i, 1);
          return;
        }
      }
    },
    // 删除转正文件
    delRegularFile(key, index, uid) {
      this.regularForm[key].splice(index, 1);
      for (var i = 0; i < this.regularFileList.length; i++) {
        if (this.regularFileList[i].uid == uid) {
          this.regularFileList.splice(i, 1);
          return;
        }
      }
    },
    // 添加离职附件
    uploadDimissionChange(file, dimissionFileList) {
      this.dimissionFileList = dimissionFileList;
      // 图片类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          this.dimissionForm.imgList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 文件类型
      if (
        ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
        -1
      ) {
        this.dimissionForm.textList.push(file);
      }
    },
    // 添加再入职附件
    uploadInductionChange(file, inductionFileList) {
      this.inductionFileList = inductionFileList;
      // 图片类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          this.inductionForm.imgList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 文件类型
      if (
        ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
        -1
      ) {
        this.inductionForm.textList.push(file);
      }
    },
    //添加转正附件
    uploadRegularChange(file, regularFileList) {
      this.regularFileList = regularFileList;
      // 图片类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          this.regularForm.imgList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 文件类型
      if (
        ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
        -1
      ) {
        this.regularForm.textList.push(file);
      }
    },
    // 显示更新工号输入框
    showEmid() {
      if (this.permissions["RocketIdentity.Users.UpdateEmId"]) {
        this.isEmIdShow = true;
      } else {
        this.$message.warning({
          message: `您暂无更新员工工号权限`,
          showClose: true,
        });
      }
    },
    // 更新工号
    updateEmid() {
      this.isEmIdShow = false;
      if (this.employe.emId) {
        let data = {
          emId: this.employe.emId,
          concurrencyStamp: this.employe.concurrencyStamp,
        };
        updateEmid(this.id, data).then((res) => {
          if (res) {
            this.$message.success({ message: "工号保存成功", showClose: true });
          }
          this.getUserInfo();
        });
      }
    },
    // 更新员工信息
    updateUser() {
      switch (this.employe.tryWorkDays) {
        case "一个月":
          this.employe.tryWorkDays = 30;
          break;
        case "两个月":
          this.employe.tryWorkDays = 60;
          break;
        case "三个月":
          this.employe.tryWorkDays = 90;
          break;
        case "" || "请选择期限":
          this.employe.tryWorkDays = 0;
          break;
      }
      this.employe.userName = this.employe.phoneNumber;
      var formData = new FormData();
      formData.append("User", JSON.stringify(this.employe));
      if (JSON.stringify(this.photoFile) != "{}") {
        formData.append("PhotoFile", this.photoFile);
      }
      updateUser(this.id, formData).then((res) => {
        this.getUserInfo();
        if (this.isTagChange) {
          if (res) {
            this.$message.success({ message: "标签保存成功", showClose: true });
          }
          this.isTagChange = false;
        } else if (this.isRemarkChange) {
          if (res) {
            this.$message.success({ message: "备注保存成功", showClose: true });
          }
          this.isRemarkChange = false;
        } else {
          if (res) {
            this.$message.success({
              message: "员工信息保存成功",
              showClose: true,
            });
          }
        }
      });
    },
    // 获取员工信息
    getUserInfo() {
      getUserDetails(this.id).then((res) => {
        this.employeInfo = res.result;
        this.employeInfo.status = this.employeInfo.status
          ? this.employeInfo.status
          : "试用期";
        this.employe = deepCopy(this.employeInfo);
        switch (this.employeInfo.tryWorkDays) {
          case 30:
            this.employe.tryWorkDays = "一个月";
            break;
          case 60:
            this.employe.tryWorkDays = "两个月";
            break;
          case 90:
            this.employe.tryWorkDays = "三个月";
            break;
          default:
            this.employe.tryWorkDays = "请选择期限";
        }
        if (this.loading) {
          this.loading = false;
          this.$emit("loading", false);
        }

        // 所属渠道人员
        if (res.result.channelId) {
          getUserDetails(res.result.channelId).then((res) => {
            console.log(res);
            this.$set(this.employeInfo, "channel", res.result.name);
            this.$set(this.employe, "channel", res.result.name);
            this.isChannelShow = false;
          });
        }
      });
    },
    // 头部初始化
    headerInit() {
      let headerEl = document.querySelectorAll(".header-top");
      if (headerEl[1]) {
        headerEl[1].style.width = headerEl[0].offsetWidth + "px";
        document.querySelector(".scroll-box").style.width =
          document.querySelector(".basic-info").offsetWidth + "px";
        this.isHeaderInit = true;
      }
    },
    // 头部滚动样式
    scrollScreen() {
      let el = document.querySelector(".main-container");
      this.scroll = el.scrollTop;
      if (this.scroll > 0) {
        this.isHeaderVisible = true;
      } else {
        this.isHeaderVisible = false;
      }
      if (this.scroll >= 25) {
        this.isHeaderShadow = true;
      } else {
        this.isHeaderShadow = false;
      }
      if (this.scroll >= 339) {
        this.isScrollShow = true;
      } else {
        this.isScrollShow = false;
      }
    },
    // 打印工牌
    goPrint() {
      // TODO:工牌打印暂停使用
      // this.$router.push("/hr/employe/print/" + this.id);
    },
    // 编辑备注
    editRemarks() {
      this.isRemarkShow = true;
      this.remarkForm.more = deepCopy(this.employe.more);
    },
    // 提交备注
    submitRemark() {
      this.isRemarkShow = false;
      this.employe.more = this.remarkForm.more;
      this.isRemarkChange = true;
      this.updateUser();
    },
    // 添加标签
    addTag() {
      this.isTagsShow = false;
    },
    // 删除标签
    delTag(i) {
      this.employe.tags.splice(i, 1);
    },
    // 保存标签
    submitTag(isEnter) {
      if (this.headTag) {
        this.employe.tags.push(this.headTag);
        this.headTag = "";
      }
      if (!isEnter) {
        this.isTagChange = true;
        this.updateUser();
        this.isTagsShow = true;
      }
    },
    goPrintInfo(v) {
      this.$router.push("/hr/employe/information/" + v + "/" + this.id);
    },
    // 驳回异动
    refuse(id) {
      this.isRejectShow = true;
      this.refuseIdRecordId = id;
    },
    // 驳回确认回调
    submitReject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            reviewStatus: "refuse",
            refusedReason: this.rejectForm.reason,
          };
          changeRecordsReview(this.refuseIdRecordId, data).then((res) => {
            if (res.code == 10200) {
              this.$message.success({ message: "驳回成功", showClose: true });
            }
          });
          this.isRejectShow = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 通过审核岗位调整
    pass(id) {
      this.$confirm(`是否通过审核？`, "异动审核", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          changeRecordsReview(id, { reviewStatus: "success" }).then((res) => {
            if (res) {
              this.$message.success({ message: "审核通过", showClose: true });
            }
            this.getUserJobs();
            this.getUserInfo();
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 切换入职
    switchDimission() {
      if (this.switchDimissionBtn == "离职") {
        this.isDimissionShow = true;
      } else {
        this.isInductionShow = true;
      }
    },
    // 再入职确认回调
    submitInduction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = deepCopy(this.inductionForm),
            post = form.grade[0].split(" "),
            position = form.grade[1].split(" "),
            org = form.organization.split(" ");
          form.postId = post[0];
          form.positionId = position[0];
          form.organizationUnitId = org[0];
          form.organization = org[1];
          form.grade = [post[1], position[1]];
          if (form.tryWorkDays == "三个月") {
            form.tryWorkDays = "90";
          }
          let data = deepCopy(form);
          delete data.grade;
          data.effectiveTime = dateFormat(data.effectiveTime);
          this.updateStatus(data);
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 确认转正回调
    submitRegular(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            status: "nomail",
            effectiveTime: dateFormat(this.regularForm.effectiveTime),
            more: this.regularForm.more,
          };
          this.updateStatus(data);
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 更新用户状态 离职/转正
    updateStatus(data) {
      this.isBtnLoading = true;
      updateStatus(this.id, data)
        .then((res) => {
          if (
            this.regularFileList.length ||
            this.dimissionFileList.length ||
            this.inductionFileList.length
          ) {
            let formData = new FormData(),
              type;
            if (data.status == "nomail") {
              type = "转正申请表";
              this.regularFileList.map((item) => {
                formData.append("Files", item.raw);
              });
            } else if (data.status == "fired") {
              type = "离职申请表";
              this.dimissionFileList.map((item) => {
                formData.append("Files", item.raw);
              });
            } else if (data.status == "probation") {
              type = "再入职申请表";
              this.inductionFileList.map((item) => {
                formData.append("Files", item.raw);
              });
            }
            formData.append("EnableClearUpTheMaterialsForThisType", false);
            formData.append("Type", type);
            uploadMaterials(this.id, formData).then((res) => {
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              this.isRegularShow = false;
              this.isDimissionShow = false;
              this.isInductionShow = false;
              this.isBtnLoading = false;
            });
          } else {
            if (res) {
              this.$message.success({
                message: "提交成功",
                showClose: true,
              });
            }
            this.isRegularShow = false;
            this.isDimissionShow = false;
            this.isInductionShow = false;
            this.isBtnLoading = false;
          }
          this.getUserInfo();
        })
        .catch((err) => {
          this.isBtnLoading = false;
        });
    },
    // 离职确认回调
    submitDimission(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            status: "fired",
            effectiveTime: dateFormat(this.dimissionForm.effectiveTime),
            firedReason: this.dimissionForm.firedReason,
            more: this.dimissionForm.more,
          };
          this.updateStatus(data);
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 切换员工账号状态
    switchAccountStatus() {
      if (this.permissions["RocketIdentity.Users.Lockout"]) {
        if (!this.employeInfo.isLockout) {
          this.isLockShow = true;
        } else {
          this.$confirm(
            `账户解冻后将恢复正常使用，是否继续操作？`,
            "账户解冻",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {
              this.submitLock();
            })
            .catch(() => {
              //console.log("已取消");
            });
        }
      } else {
        let text = this.employeInfo.isLockout ? "解冻" : "冻结";
        this.$message.warning({
          message: `您暂无${text}员工账户权限`,
          showClose: true,
        });
      }
    },
    // 提交员工账号状态
    submitLock() {
      let query = {
        isLockout: !this.employeInfo.isLockout,
        lockoutReason: this.lockForm.more,
        concurrencyStamp: this.employeInfo.concurrencyStamp,
      };
      userLockout(this.id, query).then((res) => {
        let msg = this.employeInfo.isLockout ? "解冻成功" : "冻结成功";
        if (res) {
          this.$message.success({ message: msg, showClose: true });
        }
        this.getUserInfo();
      });
      this.isLockShow = false;
    },
    // 重置密码
    resetPassword() {
      if (this.permissions["RocketIdentity.Users.ResetPassword"]) {
        this.$confirm(
          `重置密码后，请尽快通知用户修改密码，初始密码为${this.defaultPassword}`,
          "重置密码",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            resetPassword(this.id).then((res) => {
              if (res) {
                this.$message.success({
                  message: "密码重置成功",
                  showClose: true,
                });
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: `您暂无重置密码权限`,
          showClose: true,
        });
      }
    },
    // 关闭窗口回调
    handleClose(formName) {
      this.$refs[formName].resetFields();
      if (formName == "regularForm") {
        this.regularForm.imgList = [];
        this.regularForm.textList = [];
        this.regularFileList = [];
      } else if (formName == "dimissionForm") {
        this.dimissionForm.imgList = [];
        this.dimissionForm.textList = [];
        this.dimissionFileList = [];
      } else if (formName == "inductionForm") {
        this.inductionForm.imgList = [];
        this.inductionForm.textList = [];
        this.inductionFileList = [];
      }
    },
    // 移除岗位
    deletePosition(rows) {
      if (this.isManageJobsAuth) {
        this.$confirm(`是否移除该岗位？`, "移除岗位", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            removeUserJob(this.id, rows).then((res) => {
              if (res.code == 10200) {
                this.$message.success({ message: "移除成功", showClose: true });
                this.getUserJobs();
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: `您暂无管理员工岗位权限`,
          showClose: true,
        });
      }
    },
    // 添加岗位
    addPosition() {
      if (this.isManageJobsAuth) {
        this.positionEditTitle = "添加新岗位";
        this.isPositionShow = true;
      } else {
        this.$message.warning({
          message: `您暂无管理员工岗位权限`,
          showClose: true,
        });
      }
    },
    // 调整岗位
    adjustPosition(index, v) {
      if (this.isManageJobsAuth) {
        this.positionEditTitle = v.isMajor ? "主岗调整" : "岗位调整";
        this.isPositionShow = true;
        this.originalPosition = v;
      } else {
        this.$message.warning({
          message: `您暂无管理员工岗位权限`,
          showClose: true,
        });
      }
    },
    // 岗位异动确认回调
    submitPosition(formName) {
      //console.log(this.positionForm, "positionForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = deepCopy(this.positionForm),
            post = form.grade[0].split(" "),
            position = form.grade[1].split(" "),
            org = form.organization.split(" ");
          this.positionForm.postId = post[0];
          this.positionForm.positionId = position[0];
          this.positionForm.organizationUnitId = org[0];
          this.positionForm.organization = org[1];
          this.positionForm.grade = [post[1], position[1]];
          if (this.originalPosition.post) {
            // 岗位调整
            this.positionForm.isMajor = this.originalPosition.isMajor;
            let newJob = deepCopy(this.positionForm);
            let oldJob = deepCopy(this.originalPosition);
            let data = {
              oldPostId: oldJob.postId,
              oldPositionId: oldJob.positionId,
              oldOrganizationUnitId: oldJob.organizationUnitId,
              postId: newJob.postId,
              positionId: newJob.positionId,
              organizationUnitId: newJob.organizationUnitId,
              effectiveTime: dateFormat(newJob.effectiveTime),
              isMajor: newJob.isMajor,
              more: newJob.more,
            };
            updateUserJobs(this.id, data).then((res) => {
              if (res && res.result) {
                let msg;
                if (newJob.isMajor) {
                  msg = "提交成功";
                } else {
                  msg = "岗位调整成功";
                }
                this.$message.success({
                  message: msg,
                  showClose: true,
                });
                this.getUserJobs();
              }
            });
          } else {
            // 岗位添加
            if (this.jobs.length) {
              this.positionForm.isMajor = false;
            } else {
              this.positionForm.isMajor = true;
            }
            let data = deepCopy(this.positionForm);
            delete data.grade;
            data.effectiveTime = dateFormat(data.effectiveTime);
            //console.log(data, "this.positionForm");
            addUserJob(this.id, data).then((res) => {
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              this.getUserJobs();
            });
          }
          this.isPositionShow = false;
          this.originalPosition = {};
          this.positionForm = {
            grade: "",
            department: "",
            effectiveDate: "",
            more: "",
            isMajorJob: false,
          };
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 设置主岗位
    setUpPosition(v) {
      if (this.isManageJobsAuth) {
        this.majorJob = `${v.organizationUnit.name}-${v.post.name}-${v.position.name}`;
        this.majorJobInfo = v;
        this.isMajorJobShow = true;
      } else {
        this.$message.warning({
          message: `您暂无管理员工岗位权限`,
          showClose: true,
        });
      }
    },
    // 确认设置主岗位回调
    submitMajorJob(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            postId: this.majorJobInfo.postId,
            positionId: this.majorJobInfo.positionId,
            organizationUnitId: this.majorJobInfo.organizationUnitId,
            effectiveTime: this.majorJobForm.creationTime,
            isMajor: true,
            more: this.majorJobForm.more,
          };
          updateMajorJob(this.id, data).then((res) => {
            if (res.code == 10200) {
              this.$message.success({
                message: res.message,
                showClose: true,
              });
              this.isMajorJobShow = false;
              this.getUserInfo();
              this.getUserJobs();
            }
          });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 保存用户信息
    editInfo(v) {
      this.$refs.employeForm.validate((valid) => {
        if (valid) {
          this.updateUser();
          this.isEditInfo[v] = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 取消保存回调
    cancel(v) {
      this.employe = deepCopy(this.employeInfo);
      this.isEditInfo[v] = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.header-top {
  position: fixed;
  top: 48px;
  z-index: 99;
  display: none;
  align-items: center;
  height: 60px;

  font-size: 16px;
  font-weight: bold;

  color: #000;
  background-color: #fff;

  .left {
    display: flex;
    align-items: center;

    .header-back {
      display: flex;
      align-items: center;
      justify-content: center;

      margin: 0 23px 0 16px;
      height: 26px;
      width: 26px;
      cursor: pointer;

      &:hover {
        background-color: #f2f2f2;
      }

      .header-svg {
        width: 14px;
        height: 14px;
        color: $--color-primary;
      }
    }

    span {
      position: relative;
      top: -2px;
    }
  }

  .scroll-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    min-width: 949px;

    .left-scroll {
      display: flex;
      align-items: center;

      .scroll-head {
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }

      .scroll-main {
        display: flex;
        align-items: baseline;

        .scoll-name {
          margin-left: 11px;
          font-size: 20px;
          font-weight: bold;
          color: #000;
        }

        .scroll-post {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
          color: #000;
        }
      }
    }

    .right-scroll {
      display: flex;
      justify-content: space-between;

      .el-button {
        color: $--color-primary;
        border-color: $--color-primary;
      }
    }
  }
}

.header-visible {
  display: flex;
}

.box-shadow {
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
}

.header-top {
  margin-left: -20px;

  .scroll-box {
    left: 20px;
  }
}

.basic-info {
  text-align: left;
  min-width: 949px;
  position: relative;

  .basic-head {
    margin-bottom: 20px;
    padding: 24px 24px 20px;
    border-radius: $--border-radius-base;
    background: #fff;
    // box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

    .head-main {
      display: flex;
      position: relative;
      width: 100%;
      height: 165px;

      .main-left {
        border-radius: $--border-radius-base;
        width: 100%;
        display: flex;

        .head-box {
          position: relative;
          margin-right: 20px;
          width: 142px;
          height: 100%;

          .head-btn {
            display: none;
            justify-content: center;
            align-items: center;

            position: absolute;
            left: 0;
            bottom: 0;

            width: 100%;
            height: 40px;

            font-size: 12px;
            font-weight: 400;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);
            cursor: pointer;
          }

          &:hover .head-btn {
            display: flex;
          }

          .head-img {
            width: 100%;
            height: 100%;
            // border:1px solid #666;
            box-shadow: 0px 0px 1px 0 rgba(0, 0, 0, 0.2);
          }
        }

        .head-items {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          padding: 7px 0;
          width: calc(100% - 162px);
          font-size: 14px;
          font-weight: 400;
          color: #000;

          .head-tags {
            display: flex;
            align-items: center;
            height: 34px;
            width: 100%;
          }

          .head-item {
            display: flex;
            align-items: center;

            .basic-name {
              margin-right: 5px;
              font-size: 20px;
              font-weight: bold;
              color: #000;
            }

            .medal-img {
              margin: 2px 5px 0 1px;
              width: 16px;
              height: 22px;
            }

            .job-num {
              align-self: flex-end;
              margin-left: 5px;
            }

            .tags-items {
              display: flex;
              align-items: center;
              margin-right: 4px;

              .tag {
                margin-right: 6px;
                padding: 6px 12px;
                white-space: nowrap; /* 不换行 */
                background: #f2f2f2;
              }
            }

            .tag-btn {
              white-space: nowrap; /* 不换行 */
              color: $--color-primary;
              cursor: pointer;
            }
          }

          .tags-box {
            align-items: center;
          }

          .tags-input {
            display: flex;
            align-items: center;
            width: 100%;

            .input-box {
              display: flex;
              align-items: center;
              width: calc(100% - 34px);

              padding: 0 9px;
              border: 1px solid #ddd;
              height: 34px;
              box-sizing: border-box;

              .tag {
                display: flex;
                align-items: center;

                margin-right: 6px;
                padding: 0 12px;
                height: 24px;
                background: #f2f2f2;

                .tag-text {
                  white-space: nowrap; /* 不换行 */
                }

                .svg-icon {
                  margin-left: 10px;
                  cursor: pointer;
                }
              }

              .el-input {
                width: 200px;
                ::v-deep .el-input__inner {
                  padding: 0;
                  border-color: transparent;
                }
              }
            }

            .input-btn {
              margin-left: 10px;
              color: $--color-primary;
              white-space: nowrap; /* 不换行 */
              cursor: pointer;
            }
          }
        }
      }

      .z-index {
        z-index: 3;
      }

      .main-right {
        border-radius: $--border-radius-base;
        position: absolute;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        box-sizing: border-box;
        padding: 5px 0 8px;
        height: 100%;
        z-index: 2;

        .right-items {
          display: flex;
          justify-content: space-between;

          width: 318px;
          color: #444;
          text-align: center;

          .item-value {
            margin-top: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #ff9900;
          }

          .quitted {
            color: #ec5050;
          }
        }

        .right-btns {
          display: flex;
          justify-content: space-between;

          .el-button {
            color: $--color-primary;
            border-color: $--color-primary;
          }
        }
      }
    }

    .head-line {
      margin: 25px 0 12px;
      width: 100%;
      height: 1px;
      background: #ddd;
    }

    .head-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .svg-icon {
        cursor: pointer;
      }

      .bottom-left {
        display: flex;
        align-items: center;
        cursor: pointer;

        .mark-box {
          margin-left: 10px;
        }
      }

      .bottom-right {
        display: flex;
        justify-content: space-between;
        width: 50px;
        font-size: 16px;
      }
    }
  }

  .to-audit {
    margin-bottom: 20px;
    border: 1px solid #97c7ff;
    padding: 10px 20px;

    font-size: 12px;
    font-weight: 400;

    color: #003b80;
    background: #e5f0ff;

    .audit-top {
      font-size: 12px;
      font-weight: bold;
      color: rgba(0, 59, 128, 1);
    }

    .audit-item-btn {
      color: $--color-primary;
      cursor: pointer;
    }
  }

  .basic-item {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    background: #fff;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

    .post-symbol {
      color: #f56c6c;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .basic-item-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .add-position {
      margin-bottom: 10px;
    }

    .basic-title-edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .basic-edit {
        font-size: 14px;
        font-weight: 400;
        color: $--color-primary;
        cursor: pointer;
      }
    }

    .basic-item-main {
      margin-bottom: 25px;
      padding-bottom: 15px;
      display: flex;
      border-bottom: 1px solid #ddd;

      .main-item {
        width: 50%;

        .el-select,
        .el-input {
          width: 330px;
        }

        .work-card {
          .work-card-item {
            display: flex;
            align-items: flex-end;
            margin-bottom: 15px;
            line-height: 0;

            .default-img,
            .work-card-img {
              margin-right: 10px;
              width: 143px;
              height: 148px;
            }

            .upload-btn {
              border: 1px solid rgba(221, 221, 221, 1);
              width: 110px;
              height: 30px;
              font-size: 12px;
              font-weight: 400;
              color: #000;
            }
          }

          .work-card-print {
            margin-bottom: 0;
          }

          .upload-tip {
            font-size: 12px;
            font-weight: 400;
            color: #888;
            line-height: 0;
          }
        }

        .encrypt-number {
          display: flex;

          span {
            display: inline-block;
            // width: 100px;
          }

          .show-svg {
            margin-left: 8px;

            .svg-icon {
              margin-top: -2px;
              cursor: pointer;
            }
          }
        }

        .phone-number {
          // span {
          //   width: 75px;
          // }
        }

        .job-num-box {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #000;
          vertical-align: middle;

          p {
            margin: 0;
          }

          .job-num-btn {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            color: $--color-primary;
            cursor: pointer;
          }

          .el-input {
            width: 200px;
          }
        }

        .account-lock {
          display: inline-block;
          margin-right: 5px;
        }

        .lockout-box {
          display: flex;
          align-items: center;

          .svg-icon {
            margin-right: 5px;
          }
        }

        .is-lockout {
          color: #f44242;
        }

        .not-lockout {
          color: #0abf5b;
        }

        .work-age {
          display: flex;
          width: 330px;

          .el-input {
            width: 50%;
            &:first-child {
              ::v-deep .el-input-group__append {
                border-right-color: transparent;
              }
            }
          }
        }

        ::v-deep .el-form-item__content {
          .el-input-group {
            vertical-align: baseline;
          }
        }
      }

      .basic-item-right {
        padding-left: 50px;
      }
    }

    .basic-main-edit {
      margin-bottom: -20px;
      border-bottom: 0;

      .el-form-item {
        height: 30px;
        margin-bottom: 14px;
      }
    }

    .el-table {
      margin-bottom: 25px;
      .table-empty {
        color: $--color-primary;
        cursor: pointer;
      }
      .grade-box {
        display: flex;
        align-items: baseline;

        .grade-main {
          margin-left: 9px;
          border: 1px solid $--color-primary;
          padding: 0 5px;

          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: $--color-primary;
        }
      }
    }
  }

  .group-btn {
    margin-top: -5px;
  }

  .employe-remark {
    .el-form {
      margin-bottom: 15px;

      .el-textarea {
        width: 464px;
      }
    }

    .lock-info {
      margin-bottom: 20px;
      color: #e6a23c;
    }
  }
  ::v-deep .el-date-editor {
    .el-input__inner {
      padding-left: 30px;
    }
    .el-icon-circle-close {
      right: 0;
    }
  }
  .el-dialog {
    .dialog-tip {
      margin-top: 0px;
      margin-left: 4rem;
      width: 504px;

      font-size: 12px;
      font-weight: 400;
      line-height: 18px;

      color: #e6a23c;
    }
    .majorJob-tip {
      margin-left: 5rem;
    }
    .dialog-tip-regular {
      margin-left: 6rem;
    }
    .dialog-tip-dimission {
      margin-left: 6rem;
      width: 410px;
    }

    .regular-date {
      margin-top: -5px;
    }

    .margin-bottom {
      margin-bottom: 22px;
    }
  }

  .lock-dialog {
    .el-form {
      .el-textarea {
        width: 440px;
      }
    }
  }

  .regular-dialog {
    .select-inline,
    .el-select,
    .el-date-editor {
      width: 404px;

      ::v-deep .el-icon-date {
        left: 368px;
      }
    }
    .select-inline {
      width: 100%;
      .el-form-item {
        width: 50%;
        .el-select {
          width: 100%;
        }
      }

      .work-days {
        ::v-deep .el-input__inner {
          &:focus {
            border-color: #ddd;
          }
        }

        &:hover,
        &:focus {
          ::v-deep .el-input__inner {
            border-color: #ddd;
          }
        }
      }

      .induction-status {
        ::v-deep .el-input__inner {
          border-right-color: transparent;
          &:focus {
            border-color: #ddd;
            border-right-color: transparent;
          }
        }
        &:hover,
        &:focus {
          ::v-deep .el-input__inner {
            border-color: #ddd !important;
          }

          & + .work-days {
            ::v-deep .el-input__inner {
              border-left-color: transparent;
            }
          }
        }
      }

      .custom-width {
        width: 100%;
      }
    }
  }

  .dimission-dialog {
    .el-select {
      width: 396px;
    }
  }

  ::v-deep .employe-dialog {

    .el-dialog__body {

      .vue-treeselect__input-container {
        height: 28px;
      }

      .tree-select {
        width: 300px;
      }

      .vue-treeselect__menu {
        width: 358px!important;
      }

      .add-record-content {
        .flex {
          flex-wrap: wrap;
        }
        .media-group {
          @include flex(row, center);
          flex-wrap: wrap;
        }
        .img-group,
        .video-group {
          position: relative;
          width: 128px;
          height: 72px;
          margin-right: 10px;
          margin-bottom: 10px;
          .img,
          .video {
            width: 100%;
            height: 100%;
            background-color: #000;
          }
        }
        .img-group {
          .info {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            @include flex(column, flex-star);
            justify-content: flex-end;
            color: #fff;
            transition: all ease 0.3s;
            cursor: pointer;
            opacity: 0;
            line-height: normal;
            padding: 3px;
            box-sizing: border-box;
            .name {
              padding-bottom: 10px;
            }
            .flex-between {
              width: 100%;
              .del-icon {
                width: 12px;
                height: 12px;
                color: #fff;
              }
            }
          }
          &:hover {
            .info {
              opacity: 1;
            }
          }
        }
        .video-group {
          cursor: pointer;
          .play {
            width: 30px;
            height: 30px;
            position: absolute;
            top: calc(50% - 15px);
            left: calc(50% - 15px);
            background-color: #fff;
            border-radius: 50%;
            @include flex(row, center);
            justify-content: center;
            opacity: 0.7;
            transition: all ease 0.3s;
            .arrow {
              color: #45adf4;
              transform: rotate(-90deg);
              margin-left: 2px;
            }
          }
          .info {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            @include flex(column, flex-star);
            justify-content: flex-end;
            color: #fff;
            transition: all ease 0.3s;
            cursor: pointer;
            opacity: 0;
            line-height: normal;
            padding: 3px;
            box-sizing: border-box;
            .name {
              padding-bottom: 10px;
            }
            .flex-between {
              width: 100%;
              .del-icon {
                width: 12px;
                height: 12px;
                color: #fff;
              }
            }
          }
          &:hover {
            .info {
              opacity: 1;
            }
          }
        }

        .files-group {
          box-sizing: border-box;
          &:last-child {
            padding-bottom: 0;
          }
          .file {
            padding-bottom: 8px;
            line-height: normal;
            .file-title {
              color: #444;
            }
            .file-size {
              color: #666;
              padding-left: 16px;
            }
            .file-action {
              padding-left: 16px;
              color: $--color-primary;
              cursor: pointer;
            }
          }
        }
      }
    }

    .upload-btn {
      margin-right: 10px;
    }
  }

  @media (min-width: 1440px) and (max-width: 1680px) {
    .table-operation {
      width: 200px;
    }
  }

  @media (min-width: 1680px) {
    .table-operation {
      min-width: 250px;
    }
  }
}

.encrypt-number {
  display: flex;
  align-items: center;

  span {
    display: inline-block;
    // width: 140px;
  }

  .show-svg {
    margin-left: 8px;
    .svg-icon {
      margin-top: 1px;
      cursor: pointer;
    }
  }
}
</style>